import * as React from 'react';
import { RouterProvider } from 'react-router-dom';


import { useTranslation } from "react-i18next";

import {StateService} from 'api-client/services/StateService';

import { useServerState } from 'api/useServerState';

// routing
import router from 'routes';

// project imports
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
import RTLLayout from 'ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';
import Notistack from 'ui-component/third-party/Notistack';
import Metrics from 'metrics';

import { useEffect, useMemo } from 'react';
import SessionContext, { type Session, defaultSession } from './SessionContext';
import {useLogger} from './components/Logger';

import ThemeCustomization from 'themes';

// auth provider
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import { Box } from 'ui-component/mui';
// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
// import { SupabseProvider as AuthProvider } from 'contexts/SupabaseContext';

// ==============================|| APP ||============================== //




export default function App() {
  const { t, i18n } = useTranslation();
  const [session, setSession] = React.useState<Session | null>(defaultSession);
  const logger = useLogger();
  const disabled=false;
  //const serverState = useServerState();
  const loading = session?.loading ?? false;
  const sessionContextValue = React.useMemo(
    () => ({
      session,
      setSession,
      loading,
    }),
    [session, loading],
  );

  useEffect(() => {
    const saveUserState = async () => {
      //logger.debug('Session changed BUT NOT SAVED');
      // if (session?.user?.email) {      
      //   logger.debug('Saving state');
      //   await StateService.saveUserState(session?.user?.email,session);
      // }
    };

    saveUserState();
  }, [session]);




  return (
    <>
    <Box
          component="fieldset"
          disabled={disabled}
          sx={{
            border: 0,
            padding: 0,
            margin: 0,
            minWidth: 0,
          }}
        >
      <ThemeCustomization>
        <RTLLayout>
          <SessionContext.Provider value={sessionContextValue}>
          <Locales>
            <NavigationScroll>
              <AuthProvider>
                <>
                  <Notistack>
                    <RouterProvider router={router} />
                    <Snackbar />
                  </Notistack>
                </>
              </AuthProvider>
            </NavigationScroll>
          </Locales>
          </SessionContext.Provider>
        </RTLLayout>
      </ThemeCustomization>
      <Metrics />
      </Box>
    </>
  );
}
